export class ChangePasswordModel {
  public currentPassword: string;
  public newPassword: string;
  public confirmPassword: string;
  public userName: string;
}
